import { Box, IconButton, Stack, Typography } from '@mui/material'
import { MoreVertical20Regular } from '@/components/Icon'
import ConnectionStatusChip from '@/components/Settings/ConnectionStatusChip'
import shared from '@/components/Settings/settingsShared.module.scss'
import { featureFlags } from '@/config/featureFlags'

export default function ConnectionsDirectoryRow({ row, isLast, menuAnchor, menuRowId, onOpenRowMenu }) {
  return (
    <Box
      component="li"
      aria-label={row.title}
      className={isLast ? shared.connectionRowLast : shared.connectionRow}
    >
      <Stack direction="row" className={shared.connectionRowInner}>
        {row.iconUrl ? (
          <Box component="img" src={row.iconUrl} alt="" width={24} height={24} className={shared.connectionIcon} />
        ) : (
          <Typography component="span" aria-hidden className={shared.connectionGlyph}>
            {row.title.slice(0, 1).toUpperCase()}
          </Typography>
        )}
        <Stack direction="column" spacing={0.25} className={shared.connectionTextCol}>
          <Typography variant="body2" component="span" className={shared.connectionTitle}>
            {row.title}
          </Typography>
          {featureFlags.connectionsPageV2 && row.permissionsStatus === 'ready' ? (
            <Typography variant="caption" component="span">
              {row.approvedCount} tools always allowed{row.requiresApproval ? ' · approval required' : ''}
            </Typography>
          ) : null}
        </Stack>
        <ConnectionStatusChip uiState={row.uiState} />
        <IconButton
          type="button"
          className={`connection-row-menu-btn ${shared.connectionMenuBtn}`}
          size="small"
          aria-label={`More actions for ${row.title}`}
          aria-haspopup="true"
          aria-expanded={Boolean(menuAnchor) && menuRowId === row.id}
          onClick={(e) => onOpenRowMenu(e, row.id)}
        >
          <MoreVertical20Regular />
        </IconButton>
      </Stack>
    </Box>
  )
}
